import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

import { Variant, Color } from './index'

const colors: Record<Color, string> = {
  red: '#E85A44',
  yellow: '#F3BA2F',
  green: '#42CE61',
  blue: '#62A5EB',
  purple: '#6762F5'
}

const colorsOnHover: Record<Color, string> = {
  red: '#F6482D',
  yellow: '#F3BA2F',
  green: '#33DB54',
  blue: '#87c2ff',
  purple: '#8986e7'
}

export const ButtonStyled = styled.button<{ variant: Variant; color: Color; disabled: boolean }>`
  width: 225px;
  height: 60px;
  border: 3px solid #000000;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  -webkit-appearance: none;
  border-radius: 10px;
  background: ${props => colors[props.color]};
  font-size: 20px;
  font-weight: bold;
  font-family: ${({ theme }) => theme.typography.fontFamily.secondary};
  color: #fdf4e1;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s;

  &:hover {
    background: ${props => colorsOnHover[props.color]};
    transition: color 0.2s;
  }

  ${props =>
    props.variant === 'secondary' &&
    css`
      border: none;
      border-radius: 5px;
      font-size: 16px;
      color: #fdf3e2;
    `}
    
  ${props =>
    props.disabled &&
    css`
      background: #ccc;
      pointer-events: none;
      cursor: default;
    `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    height: 54px;
    border-width: 2px;
    font-size: 16px;
  `};
`

export const RouteLink = styled(Link)<{ disabled: boolean }>`
  ${props =>
    props.disabled &&
    css`
      pointer-events: none;
    `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
  `};
`

export const IconStyled = styled.img`
  max-width: 30px;
  max-height: 30px;
  margin-right: 10px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 22px;
    max-height: 22px;
    border-width: 2px;
  `};
`
